import type { FC } from "react";
import { hrisMappingEarningCodeIgnoreSortingKey } from "../../../../../services/LocalStorageService";
import { HrisIgnoreCategory } from "../../../../../utils/models";
import { IgnoredValueListGrid } from "./IgnoredValueListGrid";

export const EarningCodeIgnoreGrid: FC = () => (
	<IgnoredValueListGrid
		category={HrisIgnoreCategory.EarningCode}
		addButtonLabelKey="hris.mapping.ignored.addEarningCode"
		addDialogTitleKey="hris.mapping.ignored.add.dialog.titleEarningCode"
		searchPlaceholderKey="hris.mapping.ignored.search.placeholder"
		localStorageKey={hrisMappingEarningCodeIgnoreSortingKey}
		dataTestId="hris-mapping-earning-code-ignore"
	/>
);
